import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import AnimatedNumber from 'animated-number-vue';
import { abbreviate } from '@/helpers/NumeralFormatter';
let BaseAnalyticsBannerContent = class BaseAnalyticsBannerContent extends Vue {
    constructor() {
        super(...arguments);
        this.duration = 2000;
    }
    get indicator() {
        return this.increased ? 'arrow_upward' : 'arrow_downward';
    }
    toAbsolute(value) {
        return Math.floor(Number(value));
    }
    toFixed(value) {
        return Number(value).toFixed(2);
    }
    filterValue(value) {
        const options = this.$options;
        if (this.currency && !!options && !!options.filters && !!options.filters.currency) {
            return options.filters.currency(value);
        }
        if (this.abbreviated) {
            return abbreviate(value);
        }
        if (this.fixed) {
            return this.toFixed(value);
        }
        return this.toAbsolute(value);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "heading", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "subheading", void 0);
__decorate([
    Prop({ type: String, required: true })
], BaseAnalyticsBannerContent.prototype, "label", void 0);
__decorate([
    Prop({ type: [String, Number], default: '0' })
], BaseAnalyticsBannerContent.prototype, "content", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "currency", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "percentage", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], BaseAnalyticsBannerContent.prototype, "contentEnabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "fixed", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "increased", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "decreased", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "showIndicator", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "abbreviated", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "orangeText", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "textAlignLeft", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "ml4", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseAnalyticsBannerContent.prototype, "loading", void 0);
BaseAnalyticsBannerContent = __decorate([
    Component({
        components: {
            AnimatedNumber,
        },
    })
], BaseAnalyticsBannerContent);
export default BaseAnalyticsBannerContent;
